export default __webpack_public_path__ + "static/burger-bottom-36211d6115a1818deb60448e0c635e3c.png";